import HTTP from "@/http";

export function postDingYue(data = {}) {
  return HTTP({
    url: "api/dingyue",
    method: "POST",
    data,
  });
}
